import React from 'react';
import {
    SendCompanyWorkerMissingInfoEmailTask
} from "./sendMissingInfoEmail/ws/SendCompanyWorkerMissingInfoEmailTask";
import Alert from "react-s-alert";
import {
    SendCompanyWorkerMissingInfoEmailRequest
} from "./sendMissingInfoEmail/ws/SendCompanyWorkerMissingInfoEmailRequest";
import {Field, reduxForm} from 'redux-form';
import PropTypes from 'prop-types';
import {WorkerFormValidator} from './WorkerFormValidator';
import Card from '../../../shared/components/Card';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import CardBody from '../../../shared/components/CardBody';
import {I18nUtils} from '../../../../i18n/I18nUtils';
import {FormText} from '../../../shared/components/FormText';
import Row from '../../../shared/components/Row';
import {FormSwitch} from '../../../shared/components/FormSwitch';
import {FormSubmit} from '../../../shared/components/FormSubmit';
import {ResourceOutsource} from '../../../shared/components/predefined-fields/resource-outsource/ResourceOutsource';
import {
    ResourceContractorSchema
} from '../../../shared/components/predefined-fields/resource-contractor-schema/ResourceContractorSchema';
import DocumentSchemaType from '../../../shared/model/DocumentSchemaType';
import HeaderSearchRefreshFilterOptions from '../../../shared/components/HeaderSearchRefreshFilterOptions';
import ConfirmModal from '../../../shared/components/confirm-modal/ConfirmModal';

const OptionsMore = {
    NONE: '',
    ASK_INFORMATION_TO_CONTRACTOR: 'ASK_INFORMATION_TO_CONTRACTOR',
};

const FORM = {
    NAME: 'MyOutsourcesWorkerForm',
    FIELDS: {
        DNI: 'dni',
        STATE: 'state',
        NAME: 'name',
        LAST_NAME: 'lastName',
        AGREEMENT: 'agreement',
        OUTSOURCE: 'outsource',
        CONTRACTOR_ID: 'contractorId',
        CONTRACTOR_SCHEMA: 'contractorSchema',
        POSITION: 'position',
    },
};

class WorkerFormContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showSendEmailConfirmationModal: false,
            sendEmailLoading: false,
        };
    }

    showSendEmailConfirmationModal = () => {
        this.setState({showSendEmailConfirmationModal: true});
    };

    hideSendEmailConfirmationModal = () => {
        this.setState({showSendEmailConfirmationModal: false});
    };

    moreOptions() {
        const {
            moreOptionSelected,
        } = this.state;

        return [
            {
                id: 'send_email',
                title: I18nUtils.tr('TR_SOLICITAR_INFORMACION_A_LA_SUBCONTRATA'),
                active: moreOptionSelected === OptionsMore.ASK_INFORMATION_TO_CONTRACTOR,
                onClick: () => this.showSendEmailConfirmationModal(),
            },
        ];
    }

    renderHeaderOptions() {
        return (
            <HeaderSearchRefreshFilterOptions
                moreOptions={this.moreOptions()}
                enableFilter={false}
                enableSearch={false}
                enableRefresh={false}
                cardSearchFilterEnabled={false}
            />
        );
    }

    render() {
        const {
            title,
            onSubmit,
            canWrite,
            handleSubmit,
            workerId,
            contractorId,
            handleSetRefreshQrToken,
            refreshQrToken,
            handleTokenLoading,
            loading,
            canSendInfoEmail,
            initialValues,
        } = this.props;
        const {
            showSendEmailConfirmationModal,
            sendEmailLoading,
        } = this.state;

        return (
            <Card loading={loading || sendEmailLoading}>
                <CardHeader
                    title={title.toUpperCase()}
                    rightOptions={workerId && canSendInfoEmail && this.renderHeaderOptions()}
                />
                <CardBody>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.DNI}
                                label={I18nUtils.tr('TR_DNI_NIE')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_EL_DNI_NIE_DEL_TRABAJADOR')}
                                component={FormText}
                                disabled={!canWrite}
                            />
                            <Field
                                col="col-md-3"
                                name={FORM.FIELDS.STATE}
                                label={I18nUtils.tr('TR_ESTADO')}
                                labelDisabled={I18nUtils.tr('TR_INACTIVO')}
                                labelEnabled={I18nUtils.tr('TR_ACTIVO')}
                                component={FormSwitch}
                                disabled={!canWrite}
                            />
                        </Row>
                        <Row>
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.NAME}
                                label={I18nUtils.tr('TR_NOMBRE')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_EL_NOMBRE_DEL_TRABAJADOR')}
                                component={FormText}
                                disabled={!canWrite}
                            />
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.LAST_NAME}
                                label={I18nUtils.tr('TR_APELLIDO_S')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_EL_LOS_APLLIDO_S_DEL_TRABAJADOR')}
                                component={FormText}
                                disabled={!canWrite}
                            />
                        </Row>
                        <Row>
                            <Field
                                col="col-md-12"
                                name={FORM.FIELDS.AGREEMENT}
                                label={I18nUtils.tr('TR_CONVENIO_DE_APLICACION')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_EL_CONVENIO_DE_APLICACION')}
                                component={FormText}
                                disabled={!canWrite}
                            />
                        </Row>
                        <Row>
                            <ResourceOutsource
                                col="col-sm-12"
                                name={FORM.FIELDS.OUTSOURCE}
                                disabled={!canWrite}
                            />
                        </Row>
                        <Row>
                            <ResourceContractorSchema
                                col="col-sm-10"
                                name={FORM.FIELDS.CONTRACTOR_SCHEMA}
                                disabled={!canWrite}
                                documentSchemaType={DocumentSchemaType.WORKER}
                                workerId={workerId}
                                contractorId={contractorId}
                                handleSetRefreshQrToken={handleSetRefreshQrToken}
                                refreshQrToken={refreshQrToken}
                                handleTokenLoading={handleTokenLoading}
                                canWrite={canWrite}
                                showPositionField={true}
                            />
                        </Row>
                        {
                            canWrite ? (
                                <Row>
                                    <Field
                                        label={I18nUtils.tr('TR_GUARDAR')}
                                        name="submit"
                                        col="col-md-6 col-md-offset-6"
                                        component={FormSubmit}
                                    />
                                </Row>
                            ) : null
                        }
                    </form>
                </CardBody>

                <ConfirmModal
                    show={showSendEmailConfirmationModal}
                    onHide={this.hideSendEmailConfirmationModal}
                    onAccept={this.sendCompanyWorkerMissingEmail}
                    title={I18nUtils.tr('TR_SOLICITAR_INFORMACION_A_LA_SUBCONTRATA')}
                    bodyText={
                        <React.Fragment>
                            {I18nUtils.tr('TR_ESTAS_A_PUNTO_DE_ENVIAR_UN_CORREO_PARA_SOLICITAR_INFORMACION')}
                            <br/>
                            {I18nUtils.tr('TR_DESEAS_CONTINUAR')}
                        </React.Fragment>
                    }
                />
            </Card>
        );
    }

    sendCompanyWorkerMissingEmail = () => {
        const {
            workerId,
        } = this.props;

        const request = new SendCompanyWorkerMissingInfoEmailRequest(workerId);

        this.hideSendEmailConfirmationModal();
        this.setState({sendEmailLoading: true});
        new SendCompanyWorkerMissingInfoEmailTask(request.id())
            .onSuccess(() => {
                this.setState({sendEmailLoading: false});
                Alert.success(I18nUtils.tr('TR_CORREO_ENVIADO_CORRECTAMENTE'));
            })
            .onFail(error => {
                Alert.error(error);
                this.setState({sendEmailLoading: false});
            })
            .execute();
    }
}

export const WorkerForm = reduxForm({
    form: FORM.NAME,
    validate: WorkerFormValidator.validate,
})(WorkerFormContent);

WorkerForm.propTypes = {
    title: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
    canWrite: PropTypes.bool.isRequired,
    workerId: PropTypes.number,
    contractorId: PropTypes.number,
    handleSetRefreshQrToken: PropTypes.func,
    refreshQrToken: PropTypes.bool,
    handleTokenLoading: PropTypes.func,
    loading: PropTypes.bool,
    canSendInfoEmail: PropTypes.bool,
};

WorkerForm.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/form/WorkerForm.jsx